import { useLocale } from "../lib/i18n";

export function SplashPage() {
  const { t } = useLocale();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="text-4xl font-bold text-orange-500 mb-2">Mesterin</div>
      <div className="text-gray-500 text-sm">{t.loading}</div>
      <div className="mt-8 w-8 h-8 border-4 border-orange-100 border-t-orange-500 rounded-full animate-spin" />
    </div>
  );
}
